String.prototype.isVin = function() {
    return this.length === 17 && this.indexOf(' ') === -1;
}